module.exports = require("@swa-ui/placements/src/RotatingBannerPlacement/RotatingBannerPlacement.module.scss");